module.exports = __webpack_public_path__ + "img/Bucky_01.6f8ddb62.png";